/**
 * Decodifica (SENZA verifica di firma) del payload di un JWT lato browser.
 * Unico helper condiviso: lo usano `ApiClientCore` (slug tenant) e il motore
 * `session-idle` (scadenza `exp`). La firma la verifica solo il backend.
 */

function base64UrlToUtf8(segment: string): string | null {
  const normalized = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
  try {
    return atob(padded);
  } catch {
    return null;
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** Payload decodificato come mappa generica: i campi vanno narrowati dal chiamante. */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const rawPayload = token.split('.')[1];
  if (!rawPayload) return null;
  const json = base64UrlToUtf8(rawPayload);
  if (json === null) return null;
  try {
    const parsed: unknown = JSON.parse(json);
    return isRecord(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

/** Scadenza del token in millisecondi epoch (claim `exp`), o null se assente/illeggibile. */
export function decodeJwtExpMs(token: string): number | null {
  const payload = decodeJwtPayload(token);
  if (!payload) return null;
  const exp = payload.exp;
  if (typeof exp !== 'number' || !Number.isFinite(exp) || exp <= 0) return null;
  return exp * 1000;
}
